const React = require("react");
// Using CommonJS syntax because of conditional require in the PluginCard Component

const FloatingSVG = props => (
  <svg
    className="logo"
    width="100%"
    height="100%"
    viewBox="0 0 49 48"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      fillRule: `evenodd`,
      clipRule: `evenodd`,
      strokeLinejoin: `round`,
      strokeMiterlimit: `2`,
    }}
  >
    <g transform="matrix(1,0,0,1,-54,-30)">
      <g transform="matrix(0.90566,0,0,0.941176,54.9901,-10.4706)">
        <rect x="0" y="43" width="53" height="51" style={{ fill: `none` }} />
        <clipPath id="_clip1">
          <rect x="0" y="43" width="53" height="51" />
        </clipPath>
        <g
          id="Fill-ONLY"
          transform="matrix(1.08116,0,0,1.04036,0.552083,1.91667)"
        >
          <path
            d="M48,52C48,45.377 42.623,40 36,40L12,40C5.377,40 0,45.377 0,52L0,76C0,82.623 5.377,88 12,88L36,88C42.623,88 48,82.623 48,76L48,52Z"
            className="logo-frame-fill"
            style={props ? { fill: props.backgroundcolor } : {}}
          />
        </g>
        <g clipPath="url(#_clip1)">
          <g transform="matrix(1.10417,0,0,1.0625,0,0.5)">
            <path
              d="M48,52C48,45.377 42.623,40 36,40L12,40C5.377,40 0,45.377 0,52L0,76C0,82.623 5.377,88 12,88L36,88C42.623,88 48,82.623 48,76L48,52ZM46.5,52L46.5,76C46.5,81.795 41.795,86.5 36,86.5C36,86.5 12,86.5 12,86.5C6.205,86.5 1.5,81.795 1.5,76L1.5,52C1.5,46.205 6.205,41.5 12,41.5C12,41.5 36,41.5 36,41.5C41.795,41.5 46.5,46.205 46.5,52Z"
              className="logo-frame"
              style={props ? { fill: props.color } : {}}
            />
          </g>

          <g transform="matrix(1.15323,-1.10971,1.16571,1.12172,-0.16548,63.8005)">
            <path
              d="M3.66,11.4C3.713,7.119 7.206,3.659 11.5,3.659C15.794,3.659 19.287,7.119 19.34,11.4L3.66,11.4Z"
              className="logo-color-transparency"
              style={
                props ? { fill: props.color, fillOpacity: props.opacity } : {}
              }
            />
          </g>
          <g id="Logo" transform="matrix(1.10417,0,0,1.0625,-66.25,0.5)">
            <path
              d="M71.534,78.743L96.466,78.743L96.466,76.954L71.534,76.954L71.534,78.743ZM75.184,50.906C80.05,46.04 87.951,46.04 92.817,50.906C97.682,55.772 97.682,63.673 92.817,68.539C87.951,73.404 80.05,73.404 75.184,68.539C70.318,63.673 70.318,55.772 75.184,50.906ZM92.158,52.83L77.108,67.88C81.302,71.43 87.597,71.228 91.551,67.274C95.506,63.319 95.708,57.024 92.158,52.83ZM90.893,51.565C86.699,48.014 80.404,48.217 76.449,52.171C72.494,56.126 72.292,62.421 75.843,66.615L90.893,51.565Z"
              className="logo-color"
              style={props ? { fill: props.color } : {}}
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

exports.Logo = FloatingSVG;
